import { inject, InjectionToken } from '@angular/core';
import { WINDOW } from './window.token';

/**
 * This is overwritten in most cases by application config in development:
 * from default config for dev server it goes to development.ctrlchain.com
 */
export const rootUrlToken = new InjectionToken<string>('rootUrl', {
  providedIn: 'root',
  factory: () => {
    const window = inject(WINDOW);
    return `${window?.location?.origin}/`;
  },
});
